import type { DropTarget } from "@v1/types/drop-target";

import { setDropTarget } from "@v1/reducers/drag-and-drop-reducer";
import { useEditorDispatch, useEditorSelector } from "@v1/store/store";

export default function useDropTarget() {
  const dropTarget = useEditorSelector((state) => state.dragAndDrop.dropTarget);
  const dispatch = useEditorDispatch();

  return {
    dropTarget,
    setDropTarget: (dropTarget: DropTarget) => {
      return dispatch(setDropTarget(dropTarget));
    },
  };
}
